<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()

const i18nHead = useLocaleHead({ key: 'id' })

const images = import.meta.glob('~/assets/brand/*', { eager: true, import: 'default' })
const image = import.meta.glob('~/assets/image.png', { eager: true, import: 'default' })

const getSeoMeta = computed(() => {
  const title = t('layouts.title', [t(route.meta?.title as string | undefined ?? 'pages.title.index')])
  const description = 'UZO'

  return {
    title,
    ogTitle: title,
    description,
    ogDescription: description,
    ogImage: image['/assets/image.png'] as string,
    twitterImage: image['/assets/image.png'] as string,
  }
})

useSeoMeta({
  ...getSeoMeta.value,
})

useHead({
  htmlAttrs: {
    lang: i18nHead.value?.htmlAttrs?.lang ?? 'en',
    dir: i18nHead.value?.htmlAttrs?.dir ?? 'ltr',
    class: 'scroll-smooth xs:text-[16px] text-[14px]',
  },
  bodyAttrs: {
    class: 'font-fellix antialiased tracking-wide fw500',
  },
  meta: [
    ...(i18nHead.value.meta || []),
    ...(useRuntimeConfig().public.facebookDomainVerification ? [{ name: 'facebook-domain-verification', content: useRuntimeConfig().public.facebookDomainVerification }] : []),
    ...(useRuntimeConfig().public.googleSiteVerification ? [{ name: 'google-site-verification', content: useRuntimeConfig().public.googleSiteVerification }] : []),
    ...(useRuntimeConfig().public.service.version ? [{ name: 'application-version', content: useRuntimeConfig().public.service.version }] : []),
    { name: 'viewport', content: 'width=device-width,initial-scale=1,viewport-fit=cover' },
    { name: 'charset', content: 'UTF-8' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
  link: [
    ...(i18nHead.value.link || []),
    { rel: 'icon', type: 'image/x-icon', href: images['/assets/brand/favicon.ico'], sizes: 'any' },
    { rel: 'icon', type: 'image/png', href: images['/assets/brand/icon.png'], sizes: 'any' },
    { rel: 'icon', type: 'image/svg+xml', href: images['/assets/brand/logo.svg'], sizes: 'any' },
    { rel: 'apple-touch-icon', type: 'image/png', href: images['/assets/brand/apple-touch-icon.png'], sizes: 'any' },
    { rel: 'preload', href: '/fonts/fellix-400.woff2', as: 'font', crossorigin: 'anonymous' },
    { rel: 'preload', href: '/fonts/fellix-500.woff2', as: 'font', crossorigin: 'anonymous' },
    { rel: 'preload', href: '/fonts/fellix-600.woff2', as: 'font', crossorigin: 'anonymous' },
    { rel: 'preload', href: '/fonts/fellix-700.woff2', as: 'font', crossorigin: 'anonymous' },
  ],
  script: [],
})
</script>

<template>
  <RdxConfigProvider>
    <NuxtLoadingIndicator color="conic-gradient(at top right,#F43F5E 0%,#EF4444 50%,#F97316 100%)" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <UiToaster />
  </RdxConfigProvider>
</template>
